import React, { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const ScrollIndicator = () => {
  const [progress, setProgress] = useState(0);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const max =
        (document.documentElement.scrollHeight || document.body.scrollHeight) -
        window.innerHeight;
      const pct = max > 0 ? (scrollTop / max) * 100 : 0;
      setProgress(pct);
      setShow(scrollTop > 400);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Top progress bar */}
      <div
        data-testid="scroll-progress"
        className="fixed top-0 inset-x-0 h-[3px] z-50 pointer-events-none"
      >
        <div
          className="h-full bg-gradient-to-r from-brand-blue to-brand-blue-light transition-[width] duration-150 ease-out shadow-[0_0_8px_rgba(30,95,186,0.6)]"
          style={{ width: `${progress}%` }}
        />
      </div>

      {/* Back-to-top button */}
      <button
        data-testid="scroll-to-top"
        aria-label="Scroll to top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        className={`fixed right-4 lg:right-6 bottom-24 lg:bottom-6 z-40 h-12 w-12 lg:h-14 lg:w-14 rounded-full bg-brand-blue hover:bg-brand-blue-light text-white shadow-xl border-2 border-white/30 flex items-center justify-center transition-all duration-300 ${
          show
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4 pointer-events-none"
        }`}
      >
        <ArrowUp className="h-5 w-5 lg:h-6 lg:w-6" strokeWidth={2.5} />
      </button>
    </>
  );
};

export default ScrollIndicator;
